import { useEffect, useState, useContext } from 'react'
import ReimbursementSelector from '../ReimbursementSelector/ReimbursementSelector'
import TermSelectForm from '../TermSelectForm/TermSelectForm'
import UserLookupForm from '../UserLookupForm/UserLookupForm'
import { USER_KEY, REIMBURSEMENT_ID } from '../../Cookies'
import { http } from '../../AxiosConfig'
import toast, { Toaster } from 'react-hot-toast'
import { MainContext } from '../MainContext'

// TODO: get back term and POST
function UserAndTermLookup(props) {
  // TODO: set state as a form object
  const [termList, setTermList] = useState([])
  const {
    user,
    setUser,
    selectedTerm,
    setSelectedTerm,
    reimbursement,
    setReimbursement,
  } = useContext(MainContext)

  let renderForm
  // listening for an update on (dont call in function is not set has too run through first)

  useEffect(() => {
    termSelector()
    sessionStorage.setItem(USER_KEY, JSON.stringify(user))
  }, [user, termList, selectedTerm, renderForm])

  const setUserData = user => {
    setTermList([...user?.terms])
    setUser(user)
  }

  const userSelectTerm = term => {
    setSelectedTerm(term)
  }

  const termSelector = term => {
    if (selectedTerm?.hasOwnProperty('id')) {
      createReimbursement(selectedTerm)
    }
    else if (termList.length === 1) {
      setSelectedTerm(termList[0])
    }
  }

  const createReimbursement = () => {
    const reimbursement = localStorage.getItem(REIMBURSEMENT_ID)
    if (reimbursement) {
      fetchReimbursement(JSON.parse(reimbursement))
    }
    else {
      postReimbursement()
    }
  }

  const fetchReimbursement = reimId => {
    http
      .get(`/reimbursements/${reimId}`)
      .then(res => {
        setReimbursement(res.data.data)
        localStorage.setItem(REIMBURSEMENT_ID, res.data.data.attributes.id)
      })
      .catch(err => {
        // comment
        toast.error('Could not process reimbursement request.')
      })
      .finally(() => {
        // comment
      })
  }
  const postReimbursement = () => {
    const reim = {
      reimbursement: {
        user_id: user.id,
        term_id: selectedTerm.id,
        division_id: selectedTerm.division.id,
      },
    }
    http
      .post(`/reimbursements`, reim)
      .then(res => {
        setReimbursement(res.data.data)
        localStorage.setItem(REIMBURSEMENT_ID, res.data.data.attributes.id)
      })
      .catch(err => {
        toast.error('Could not process reimbursement request.')
      })
      .finally(() => {})
  }

  if (reimbursement.hasOwnProperty('id')) {
    renderForm = (
      <ReimbursementSelector
        user={user}
        reimbursement={reimbursement}
        selectedTerm={selectedTerm}
      />
    )
  }
  else if (Object.entries(user).length === 0) {
    renderForm = <UserLookupForm setUserData={setUserData} />
    // if no user i need a lookupuser page
  }
  else if (Object.entries(user.terms).length === 0) {
    renderForm = <UserLookupForm setUserData={setUserData} />
    // toast.error('No term found for this member check Divsision')
    // if no term i need a lookupuser page
  }
  else if (termList.length > 1) {
    renderForm = (
      <TermSelectForm
        termList={termList}
        user={user}
        userSelectTerm={userSelectTerm}
      />
    )
    // if a few terms i need a term selector page
  }

  return (
    <div>
      <Toaster position="top-center" reverseOrder={false} />
      {renderForm}
    </div>
  )
}
export default UserAndTermLookup
